/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkProjectCostLineDto } from '../models/work-project-cost-line-dto';

@Injectable({ providedIn: 'root' })
export class WorkProjectCostsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectCostsV2ControllerFindLines()` */
  static readonly ProjectCostsV2ControllerFindLinesPath = '/v2/project-costs';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectCostsV2ControllerFindLines()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCostsV2ControllerFindLines$Response(
    params: {
      projectIds: Array<number>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkProjectCostLineDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectCostsV2Service.ProjectCostsV2ControllerFindLinesPath, 'get');
    if (params) {
      rb.query('projectIds', params.projectIds, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkProjectCostLineDto>>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectCostsV2ControllerFindLines$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectCostsV2ControllerFindLines(
    params: {
      projectIds: Array<number>;
    },
    context?: HttpContext
  ): Observable<Array<WorkProjectCostLineDto>> {
    return this.projectCostsV2ControllerFindLines$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkProjectCostLineDto>>): Array<WorkProjectCostLineDto> => r.body)
    );
  }

}
